"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : CUSTOM CHECKBOX : STYLES --------------- ++++++++++ */


var _default = {
  checkboxwrapper: {
    display: 'flex',
    alignItems: 'center',
    '& .text': {
      marginLeft: (0, _index.pxToEm)(10)
    }
  },
  checkbox: {
    height: (0, _index.pxToEm)(30),
    width: (0, _index.pxToEm)(30),
    border: (0, _index.replacePXinStringWithEM)("2px solid #EEF2F6"),
    borderRadius: (0, _index.pxToEm)(4),
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'border .2s linear 0s',
    '&:hover': {
      borderColor: _index.theme.color.grey.medium.swatch
    },
    extend: (0, _index.themeStyleHelper)(_index.theme, 'color', function (theme, uniqueColor) {
      return {
        '&.active-true': {
          backgroundColor: theme.color[uniqueColor].medium.swatch,
          borderColor: theme.color[uniqueColor].medium.swatch,
          color: theme.color[uniqueColor].medium.contrast
        }
      };
    }),
    '&.active-false': {
      '& .name-check': {
        opacity: 0,
        transition: 'all .05s ease-out 0s'
      }
    },
    '&.active-true': {
      '& .name-check': {
        opacity: 1,
        transition: 'all .05s ease-in 0s'
      }
    }
  }
};
exports.default = _default;